import React from 'react'
import { HiOutlineTrash } from 'react-icons/hi';
import _ from 'lodash';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';



export default function OrgRegistryKeyInfoComponent ({keys,onFormItemChange,deleteKeys}: any) {

  return (
    <> 
  <div className="h-[500px] overflow-auto w-full bg-white p-4">
  <table className="w-full text-xs bg-red-50">
    <thead className="w-full border-y border-black border-opacity-20">
      <tr className="w-full text-left h-12">
        <th className="border-r-2  last:border-r-0 w-auto px-10">SIGNING_PVT_KEY</th>
        <th className="border-r-2  last:border-r-0 w-auto px-10">SIGNING_PUB_KEY</th>
        <th className="border-r-2  last:border-r-0 w-auto px-10">ENCRYPTION_PVT_KEY</th>
        <th className="border-r-2  last:border-r-0 w-auto px-10">ENCRYPTION_PUB_KEY</th>
        <th className="border-r-2  last:border-r-0 w-auto px-10">Action</th>
      </tr>
    </thead>
    <tbody className="w-full bg-red-400 h-[400px]">
      {_.map(keys,(cardValue: any, index: any) => (
        <tr key={index} className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
         
            <td 
            className="px-6 py-4  w-auto">
             <InputContainer
  isDisabled
name="signing_pvt_key"
onValueChange={(event: any) => {
  onFormItemChange({
    value: event.target.value,
    field: 'signing_pvt_key',
    idx: index
  });
} }
type="text"
value={cardValue.signing_pvt_key} />             
            </td>
            <td 
            className="px-6 py-4  w-auto">
            <InputContainer
  isDisabled
name="signing_pub_key"
onValueChange={(event: any) => {
  onFormItemChange({
    value: event.target.value,
    field: 'signing_pub_key',
    idx: index
  });
} }
type="text"
value={cardValue.signing_pub_key} />
            </td>
            <td 
            className="px-6 py-4  w-auto">
            <InputContainer
  isDisabled
                              name="encryption_pvt_key"
                              onValueChange={(event: any) => {
                                onFormItemChange({
                                  value: event.target.value,
                                  field: 'encryption_pvt_key',
                                  idx: index
                                });
                              } }
                              type="text"
                              value={cardValue.encryption_pvt_key} />
            </td>
            <td 
            className="px-6 py-4  w-auto">
            <InputContainer
  isDisabled
name="encryption_pub_key"
onValueChange={(event: any) => {
  onFormItemChange({
    value: event.target.value,
    field: 'encryption_pub_key',
    idx: index
  });
} }
type="text"
value={cardValue.encryption_pub_key} />
            </td>
          <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                  <button className="text-red-500 hover:text-red-700" onClick={async () => deleteKeys(cardValue,index)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>
                </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
</>
  )
}